export enum AllProjectsStatus {
    ALL = 'all',
    ONGOING = 'ongoing',
    COMPLETED = 'completed'
}
